import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Container,
  Badge,
} from "reactstrap";
import { getSubscriptionDetails } from "../../../../service/profile-ras-service";
import { updateSubscription } from "../../../../service/user-detail-service";
import Loading from "../../../loader/loader";
import { openNotificationWithIcon, notificationStrings } from "../../../../common/notification-message/notification";

const SubscriptionsTab = ({
  subscriptionSaveClicked,
  userId,
  buttonloader,
}) => {
  const [loader, setloader] = useState(false);
  const [actionLoader, setActionLoader] = useState({});
  const [sublist, setSubList] = useState([]);
  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getSubcriptionDetailList(id);
    }
  }, [id]);

  const getSubcriptionDetailList = (id) => {
    setloader(true);
    getSubscriptionDetails(id)
      .then((res) => {
        setloader(false);
        if (res && res.data) {
          setSubList(res.data);
        }
      })
      .catch((err) => {
        setloader(false);
        setSubList([]);
      });
  };

  const handleSubscriptionUpdate = (subscriptionId, isActive) => {
    // Set loading state for this specific subscription
    setActionLoader(prev => ({ ...prev, [subscriptionId]: true }));
    
    const subscriptionData = {
      SubscriptionId: subscriptionId,
      IsActive: isActive
    };
    
    updateSubscription(id, subscriptionData)
      .then((res) => {
        // Update the subscription list after successful update
        getSubcriptionDetailList(id);
        openNotificationWithIcon(
          notificationStrings.success,
          `Successfully ${isActive ? 'subscribed to' : 'unsubscribed from'} the service`
        );
        setActionLoader(prev => ({ ...prev, [subscriptionId]: false }));
      })
      .catch((err) => {
        console.error("Error updating subscription:", err);
        openNotificationWithIcon(
          notificationStrings.error,
          "Failed to update subscription"
        );
        setActionLoader(prev => ({ ...prev, [subscriptionId]: false }));
      });
  };

  return (
    <>
      <Container className="mt--6" fluid style={{ paddingTop: 100 }}>
        <Card className="mb-4">
          <CardHeader style={{}}>
            <h1 className="mb-0" style={{ fontSize: "15px", color: "#00344e" }}>
              Manage Subscriptions
            </h1>
          </CardHeader>

          <CardBody>
            {loader ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "150px",
                  alignItems: "center",
                }}
              >
                <Loading />
              </div>
            ) : sublist.length > 0 ? (
              sublist.map((subscription, i) => {
                return (
                  <div className="row form-group" key={i} style={{ 
                    marginBottom: "15px", 
                    padding: "10px", 
                    borderBottom: "1px solid #eee",
                    opacity: subscription.isEnabled ? 1 : 0.5,
                    pointerEvents: subscription.isEnabled ? "auto" : "none"
                  }}>
                    <div className="col-lg-4 col-md-4">
                      <strong>{subscription.title}</strong>
                    </div>
                    <div className="col-lg-4 col-md-4">
                      <Badge color={subscription.isActive ? "success" : "secondary"}>
                        {subscription.isActive ? "Subscribed" : "Not Subscribed"}
                      </Badge>
                    </div>
                    <div className="col-lg-4 col-md-4 text-right">
                      {actionLoader[subscription.id] ? (
                        <Loading color="#5e72e4" width="20px" height="20px" />
                      ) : subscription.isActive ? (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleSubscriptionUpdate(subscription.id, false)}
                        >
                          Unsubscribe
                        </Button>
                      ) : (
                        <Button
                          color="success"
                          size="sm"
                          onClick={() => handleSubscriptionUpdate(subscription.id, true)}
                        >
                          Subscribe
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-center py-4">No subscriptions available</div>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default SubscriptionsTab;
